import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {ThemeProvider} from '@primer/react-brand'

import CopilotSubNav from '../_components/CopilotSubNav'
import CallToAction from '../_components/CallToActionNew'
import PricingSection from '../_components/PricingSection'
import FootnotesSection from '../_components/FootnotesSection'
import FaqSection from '../_components/FaqSection'
import {cohortFunnelBuilder} from '../../../../lib/analytics'

import PricingBackground from '../_assets/pricing-bg.webp'
import PricingBackgroundSm from '../_assets/pricing-bg-sm.webp'

export default function NewFeaturesCopilotPlansIndex() {
  const {siteCopilotPurchaseRefresh} = useRoutePayload<{siteCopilotPurchaseRefresh: boolean}>()
  const {userHasOrgs} = useRoutePayload<{userHasOrgs: boolean}>()

  let {copilotSignupPath} = useRoutePayload<{copilotSignupPath: string}>()
  let {copilotForBusinessSignupPath} = useRoutePayload<{copilotForBusinessSignupPath: string}>()
  let {copilotForBusinessSignupPathRefresh} = useRoutePayload<{copilotForBusinessSignupPathRefresh: string}>()
  let {copilotEnterpriseSignupPath} = useRoutePayload<{copilotEnterpriseSignupPath: string}>()
  let {copilotContactSalesPath} = useRoutePayload<{copilotContactSalesPath: string}>()
  const {cft} = useRoutePayload<{cft: string}>()

  const withCft = cohortFunnelBuilder(cft)

  copilotSignupPath = withCft(copilotSignupPath, {product: 'cfi'})
  copilotForBusinessSignupPath = withCft(copilotForBusinessSignupPath, {product: 'cfb'})
  copilotForBusinessSignupPathRefresh = withCft(copilotForBusinessSignupPathRefresh, {product: 'cfb'})
  copilotEnterpriseSignupPath = withCft(copilotEnterpriseSignupPath, {product: 'ce'})
  copilotContactSalesPath = withCft(copilotContactSalesPath)

  return (
    <ThemeProvider colorMode="dark" className="lp-Copilot">
      <div className="position-relative">
        <CopilotSubNav currentUrl="/features/copilot/plans" />

        <picture>
          <source srcSet={PricingBackgroundSm} media="(max-width: 767px)" />
          <img src={PricingBackground} className="position-absolute top-0 left-0 width-full height-auto" alt="" />
        </picture>

        <PricingSection
          siteCopilotPurchaseRefresh={siteCopilotPurchaseRefresh}
          copilotSignupPath={copilotSignupPath}
          copilotForBusinessSignupPath={copilotForBusinessSignupPath}
          copilotForBusinessSignupPathRefresh={copilotForBusinessSignupPathRefresh}
          copilotEnterpriseSignupPath={copilotEnterpriseSignupPath}
          copilotContactSalesPath={copilotContactSalesPath}
          userHasOrgs={userHasOrgs}
          isExpanded
          showLabel={false}
          className="lp-Section--hero"
        />
      </div>

      <section className="lp-Section pt-0">
        <CallToAction copilotContactSalesPath={copilotContactSalesPath} />
      </section>

      <FaqSection />
      <FootnotesSection />
    </ThemeProvider>
  )
}

try{ NewFeaturesCopilotPlansIndex.displayName ||= 'NewFeaturesCopilotPlansIndex' } catch {}